// import Button from "../Dealers/Button";
// import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";
// import { ProgressBar } from "./ProgressBar";
// import styles from "./updateModal.module.css";

// export const formatDateTime = (input) => {
//   if (!input || input === "") return "";

//   let date;
//   let includeTime = true;

//   if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
//     const [day, month, year] = input.split("-").map(Number);
//     date = new Date(year, month - 1, day);
//     includeTime = false;
//   } else {
//     date = new Date(input);
//   }

//   if (isNaN(date.getTime())) return "";

//   const day = date.getDate().toString().padStart(2, "0");
//   const month = date.toLocaleString("en-US", { month: "short" });
//   const year = date.getFullYear();

//   if (!includeTime) {
//     return `${day} ${month} ${year}`;
//   }

//   const time = date.toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });

//   return `${time}, ${day} ${month} ${year}`;
// };

// const UpdateProductionDrawer = ({
//   open,
//   currentItem,
//   mode,
//   productionQty,
//   setProductionQty,
//   machine,
//   machineOptions = [],
//   setMachine,
//   status,
//   setStatus,
//   addQty,
//   completeProduction,
//   productionLoader,
//   handleSaveProduction,
//   onClose,
//   activeType,
//   productionSaveLock,
// }) => {
//   // console.log("machine value:", JSON.stringify(machine), typeof machine);
//   // console.log(
//   //   "machineOptions:",
//   //   machineOptions.map((m) => ({ value: m.value, type: typeof m.value })),
//   // );
//   // console.log("match:", machineOptions.find((m) => m.value === machine)?.label);

//   // console.log("currentItem", currentItem);

//   const requiredQty = currentItem.requiredQty || currentItem.totalQty || 0;

//   const producedQty = currentItem.producedQty || 0;
//   const entryQty = Number(productionQty) || 0;

//   const totalProduced = producedQty + entryQty;
//   const remainingQty = Math.max(requiredQty - totalProduced, 0);
//   const extraQty = Math.max(totalProduced - requiredQty, 0);

//   if (!open || !currentItem) return null;
//   const voucherNo = currentItem.voucherNo || "—";

//   // ----------------------- For History Filter -------------------------------
//   const filteredItemsHistory = (currentItem?.itemsHistory || []).filter((h) => {
//     // Order Wise → show all history
//     if (activeType === "Order Wise") {
//       return true;
//     }

//     // Item Wise / Production Line Wise
//     // → match itemNo with itemCode
//     // return h?.itemNo === currentItem?.itemCode;
//     return h?.itemId === currentItem?.itemId;
//   });

//   // console.log("activeType:", activeType);
//   // console.log("currentItem:", currentItem);
//   // console.log("itemsHistory:", currentItem?.itemsHistory);
//   // console.log("itemCode:", currentItem?.itemCode);
//   // console.log("filteredItemsHistory:", filteredItemsHistory);

//   // -----------------------------------------------------------------------
//   const conditionStatus =
//     activeType === "Order Wise"
//       ? currentItem?.status
//       : ["Completed", "Cancelled", "Ready For Dispatch"].includes(
//             currentItem?.status,
//           )
//         ? currentItem.status
//         : currentItem?.itemStatus;

//   const statusConfig = {
//     Completed: {
//       color: "#ffffff",
//       backgroundColor: "#34A853",
//       text: "Completed",
//     },
//     Cancelled: {
//       color: "#ffffff",
//       backgroundColor: "#F93E3E",
//       text: "Cancelled",
//     },
//     "Ready For Dispatch": {
//       color: "#ffffff",
//       backgroundColor: "#34A853",
//       text: "Ready For Dispatch",
//     },
//   };

//   const currentStatus = statusConfig[conditionStatus];

//   const canSaveUpdate = conditionStatus === "In Production";
//   // ----------------------------------------------

//   const handleSaveProductionClick = () => {
//     if (!canSaveUpdate || productionSaveLock.current) {
//       return;
//     }

//     handleSaveProduction();
//   };

//   return (
//     <div className={styles.modalOverlay}>
//       <div
//         className={`${styles.updateDrawer} ${
//           mode ? styles.updateDrawerDark : ""
//         }`}
//       >
//         <div className={styles.drawerHeader}>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               minWidth: 0,
//             }}
//           >
//             <h6
//               style={{
//                 margin: 0,
//                 fontSize: 16,
//                 fontWeight: 700,
//                 color: mode ? "#fff" : "#111",
//                 lineHeight: 1.2,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               Update Production{" "}
//               <span style={{ color: "#4164E3", fontWeight: 700 }}>
//                 ({voucherNo}{" "}
//                 {currentItem?.itemCode && `/ ${currentItem?.itemCode}`})
//               </span>
//             </h6>
//           </div>
//           {/* <button onClick={onClose}>✕</button> */}
//         </div>

//         <div className={styles.drawerBody}>
//           <div className={styles.drawerBody}>
//             <div className={styles.infoGrid}>
//               <div className={styles.infoCard}>
//                 <span>Required Qty</span>
//                 <strong>
//                   {currentItem.requiredQty || currentItem.totalQty || "—"}
//                 </strong>
//               </div>
//               <div className={styles.infoCard}>
//                 <span>Produced Qty</span>
//                 <strong style={{ color: "#12B76A" }}>
//                   {currentItem.producedQty}
//                 </strong>
//               </div>
//               <div className={styles.infoCard}>
//                 <span>Pending Qty</span>
//                 <strong
//                   style={{
//                     color: currentItem.pendingQty > 0 ? "#F04438" : "#12B76A",
//                   }}
//                 >
//                   {currentItem.pendingQty}
//                 </strong>
//               </div>
//             </div>

//             <div>
//               <ProgressBar
//                 produced={currentItem.producedQty}
//                 required={currentItem.requiredQty || currentItem.totalQty || 1}
//                 mode={mode}
//               />
//             </div>

//             {extraQty > 0 ? (
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#F79009",
//                 }}
//               >
//                 ⚠️ Extra Production: {extraQty} units.
//                 <br />
//                 extra production quantity add to order.
//               </div>
//             ) : (
//               remainingQty !== 0 &&
//               extraQty === 0 && (
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 600,
//                     color: "#12B76A",
//                     marginBottom: 12,
//                   }}
//                 >
//                   ✅ Current qty update to the order and finish for production
//                 </div>
//               )
//             )}

//             {remainingQty === 0 && extraQty === 0 && (
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#12B76A",
//                 }}
//               >
//                 ✅ Required production quantity completed successfully.
//               </div>
//             )}

//             {/* <div>
//               {filteredItemsHistory?.length > 0 && (
//                 <>
//                   <div
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 700,
//                       color: mode ? "#fff" : "#111",
//                       marginBottom: 8,
//                     }}
//                   >
//                     📋 Production History ({currentItem.qtyHistory.length}{" "}
//                     update
//                     {currentItem.qtyHistory.length > 1 ? "s" : ""})
//                   </div>

//                   <div
//                     style={{
//                       maxHeight: 180,
//                       overflowY: "auto",
//                       paddingRight: 4,
//                       backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
//                       padding: "3px 10px",
//                       borderRadius: 10,
//                     }}
//                   >
//                     {currentItem.itemsHistory.map((h, idx) => (
//                       <div
//                         key={idx}
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           // padding: "8px 0",
//                           padding: "5px 0",
//                           borderBottom:
//                             idx !== currentItem.itemsHistory.length - 1
//                               ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
//                               : "none",
//                         }}
//                       >
//                         <div>
//                           <span
//                             style={{
//                               color: "#12B76A",
//                               fontWeight: 600,
//                               fontSize: 14,
//                             }}
//                           >
//                             +{h.qty} units
//                           </span>
//                         </div>

//                         <span
//                           style={{
//                             color: mode ? "#ffffff" : "#6B7280",
//                             fontSize: 11,
//                             fontWeight: 500,
//                           }}
//                         >
//                           Admin{" / "} {formatDateTime(h.ts)}
//                         </span>
//                       </div>
//                     ))}

//                   </div>
//                 </>
//               )}
//             </div> */}

//             <div>
//               {filteredItemsHistory?.length > 0 && (
//                 <>
//                   <div
//                     style={{
//                       fontSize: 13,
//                       fontWeight: 700,
//                       color: mode ? "#fff" : "#111",
//                       marginBottom: 8,
//                     }}
//                   >
//                     📋 Production History ({filteredItemsHistory.length} update
//                     {filteredItemsHistory.length > 1 ? "s" : ""})
//                   </div>

//                   <div
//                     style={{
//                       maxHeight: 180,
//                       overflowY: "auto",
//                       backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
//                       padding: "3px 10px",
//                       borderRadius: 10,
//                     }}
//                   >
//                     {filteredItemsHistory.map((h, idx) => (
//                       <div
//                         key={idx}
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           padding: "7px 0",
//                           borderBottom:
//                             idx !== filteredItemsHistory.length - 1
//                               ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
//                               : "none",
//                         }}
//                       >
//                         {/* Left side */}
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 8,
//                           }}
//                         >
//                           <span
//                             style={{
//                               color: "#12B76A",
//                               fontWeight: 700,
//                               fontSize: 14,
//                             }}
//                           >
//                             {h.delta} units
//                           </span>

//                           {/* Show item only for Item/Production Line Wise */}
//                           {h.itemNo && (
//                             <span
//                               style={{
//                                 fontSize: 11,
//                                 fontWeight: 600,
//                                 color: mode ? "#D1D5DB" : "#6B7280",
//                                 backgroundColor: mode ? "#292C32" : "#E9EDF5",
//                                 padding: "3px 7px",
//                                 borderRadius: 5,
//                               }}
//                             >
//                               {h.itemNo}
//                             </span>
//                           )}
//                         </div>

//                         {/* Right side */}
//                         <span
//                           style={{
//                             color: mode ? "#ffffff" : "#6B7280",
//                             fontSize: 11,
//                             fontWeight: 500,
//                             whiteSpace: "nowrap",
//                             marginLeft: 10,
//                           }}
//                         >
//                           {h.updatedBy || "Admin"} /{" "}
//                           {formatDateTime(h.updateTime)}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </>
//               )}
//             </div>

//             {canSaveUpdate && activeType !== "Order Wise" && (
//               <>
//                 <div className={styles.formGroup}>
//                   <label>Add Production Qty</label>
//                   <input
//                     type="text"
//                     inputMode="numeric"
//                     value={productionQty}
//                     onChange={(e) => {
//                       const value = e.target.value;

//                       if (/^\d*$/.test(value)) {
//                         setProductionQty(value);
//                       }
//                     }}
//                     placeholder="Enter qty..."
//                   />
//                 </div>

//                 <div className={styles.quickBtns}>
//                   {/* <button onClick={() => addQty(10)}>+10</button>
//               <button onClick={() => addQty(20)}>+20</button>
//               <button onClick={() => addQty(50)}>+50</button> */}
//                   <Button
//                     buttonClick={completeProduction}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#ffffff"}
//                     buttonText={"Complete"}
//                   />
//                 </div>
//               </>
//             )}

//             {activeType !== "Order Wise" && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "flex-end",
//                   alignItems: "center",
//                 }}
//               >
//                 <button
//                   type="button"
//                   // onClick={handlePrintLabel}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     padding: 0,
//                     color: "#4164E3",
//                     textDecoration: "underline",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     fontWeight: 500,
//                   }}
//                 >
//                   Print Production Label
//                 </button>
//               </div>
//             )}

//             {activeType !== "Order Wise" && (
//               <VerticalDropDown2
//                 height="37px"
//                 fontSize="12px"
//                 label="Production Line"
//                 dropDownText={
//                   machineOptions.find((m) => m.value === machine)?.label ||
//                   "Select Production Line"
//                 }
//                 options={machineOptions}
//                 value={{
//                   label:
//                     machineOptions.find((m) => m.value === machine)?.label ||
//                     "Select Production Line",
//                   value: machine,
//                 }}
//                 onchange={(option) => setMachine(option.value)}
//                 disableOpen={false}
//               />
//             )}
//             {/* <div className={styles.formGroup}>
//               <label>Status</label>
//               <select
//                 value={status}
//                 onChange={(e) => setStatus(e.target.value)}
//               >
//                 <option>In Production</option>
//                 <option>Ready For Dispatch</option>
//                 <option>Completed</option>
//                 <option>Voucher</option>
//               </select>
//             </div> */}
//           </div>
//         </div>

//         <div className={styles.drawerFooter}>
//           <Button
//             buttonClick={onClose}
//             buttonText={"Close"}
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#ffffff"}
//           />

//           {/* <Button
//             loading={productionLoader}
//             buttonClick={handleSaveProduction}
//             buttonText={"Save Update"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#ffffff"}
//           /> */}

//           {activeType !== "Order Wise" && (
//             <Button
//               loading={productionLoader}
//               buttonClick={handleSaveProductionClick}
//               buttonText={currentStatus?.text || "Save Update"}
//               buttonBgColor={currentStatus?.backgroundColor || "#4164E3"}
//               buttonTextColor={currentStatus?.color || "#ffffff"}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdateProductionDrawer;

// ---------------------------- over produce qty update --------------------

import { useState } from "react";
import Button from "../Dealers/Button";
import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";
import { ProgressBar } from "./ProgressBar";
import styles from "./updateModal.module.css";

export const formatDateTime = (input) => {
  if (!input || input === "") return "";

  let date;
  let includeTime = true;

  if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
    const [day, month, year] = input.split("-").map(Number);
    date = new Date(year, month - 1, day);
    includeTime = false;
  } else {
    date = new Date(input);
  }

  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  if (!includeTime) {
    return `${day} ${month} ${year}`;
  }

  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${time}, ${day} ${month} ${year}`;
};

const UpdateProductionDrawer = ({
  open,
  currentItem,
  mode,
  productionQty,
  setProductionQty,
  machine,
  machineOptions = [],
  setMachine,
  status,
  setStatus,
  addQty,
  completeProduction,
  productionLoader,
  handleSaveProduction,
  onClose,
  activeType,
  productionSaveLock,
  handleOverSaveProduction,
}) => {
  // console.log("machine value:", JSON.stringify(machine), typeof machine);
  // console.log(
  //   "machineOptions:",
  //   machineOptions.map((m) => ({ value: m.value, type: typeof m.value })),
  // );
  // console.log("match:", machineOptions.find((m) => m.value === machine)?.label);

  // console.log("currentItem", currentItem);
  const [showOverProduceInput, setShowOverProduceInput] = useState(false);
  const requiredQty = currentItem.requiredQty || currentItem.totalQty || 0;

  const producedQty = currentItem.producedQty || 0;
  const entryQty = Number(productionQty) || 0;

  const totalProduced = producedQty + entryQty;
  const remainingQty = Math.max(requiredQty - totalProduced, 0);
  const extraQty = Math.max(totalProduced - requiredQty, 0);

  if (!open || !currentItem) return null;
  const voucherNo = currentItem.voucherNo || "—";

  // ----------------------- For History Filter -------------------------------
  const filteredItemsHistory = (currentItem?.itemsHistory || []).filter((h) => {
    // Order Wise → show all history
    if (activeType === "Order Wise") {
      return true;
    }

    // Item Wise / Production Line Wise
    // → match itemNo with itemCode
    // return h?.itemNo === currentItem?.itemCode;
    return h?.itemId === currentItem?.itemId;
  });

  // console.log("activeType:", activeType);
  // console.log("currentItem:", currentItem);
  // console.log("itemsHistory:", currentItem?.itemsHistory);
  // console.log("itemCode:", currentItem?.itemCode);
  // console.log("filteredItemsHistory:", filteredItemsHistory);

  // -----------------------------------------------------------------------
  const conditionStatus =
    activeType === "Order Wise"
      ? currentItem?.status
      : ["Completed", "Cancelled", "Ready For Dispatch"].includes(
            currentItem?.status,
          )
        ? currentItem.status
        : currentItem?.itemStatus;

  // ----------------- for over qty add in Completed case item wise ------------
  const overProduceView =
    activeType !== "Order Wise" &&
    currentItem?.itemStatus === "Completed" &&
    !["Ready For Dispatch", "Dispatched", "Cancelled"].includes(
      currentItem?.status,
    );

  // console.log(overProduceView);

  // ---------------------------------------------------------------------------

  const statusConfig = {
    Completed: {
      color: "#ffffff",
      backgroundColor: "#34A853",
      text: "Completed",
    },
    Cancelled: {
      color: "#ffffff",
      backgroundColor: "#F93E3E",
      text: "Cancelled",
    },
    "Ready For Dispatch": {
      color: "#ffffff",
      backgroundColor: "#34A853",
      text: "Ready For Dispatch",
    },
  };

  const currentStatus = statusConfig[conditionStatus];

  const canSaveUpdate = conditionStatus === "In Production";
  // ----------------------------------------------

  const handleSaveProductionClick = () => {
    if (!canSaveUpdate || productionSaveLock.current) {
      return;
    }

    handleSaveProduction();
  };

  const handleOverSaveProductionClick = () => {
    if (!overProduceView || productionSaveLock.current) {
      return;
    }

    handleOverSaveProduction();
  };

  return (
    <div className={styles.modalOverlay}>
      <div
        className={`${styles.updateDrawer} ${
          mode ? styles.updateDrawerDark : ""
        }`}
      >
        <div className={styles.drawerHeader}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              minWidth: 0,
            }}
          >
            <h6
              style={{
                margin: 0,
                fontSize: 16,
                fontWeight: 700,
                color: mode ? "#fff" : "#111",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Update Production{" "}
              <span style={{ color: "#4164E3", fontWeight: 700 }}>
                ({voucherNo}{" "}
                {currentItem?.itemCode && `/ ${currentItem?.itemCode}`})
              </span>
            </h6>
          </div>
          {/* <button onClick={onClose}>✕</button> */}
        </div>

        <div className={styles.drawerBody}>
          <div className={styles.drawerBody}>
            <div className={styles.infoGrid}>
              <div className={styles.infoCard}>
                <span>Required Qty</span>
                <strong>
                  {currentItem.requiredQty || currentItem.totalQty || "—"}
                </strong>
              </div>
              <div className={styles.infoCard}>
                <span>Produced Qty</span>
                <strong style={{ color: "#12B76A" }}>
                  {currentItem.producedQty}
                </strong>
              </div>
              <div className={styles.infoCard}>
                <span>Pending Qty</span>
                <strong
                  style={{
                    color: currentItem.pendingQty > 0 ? "#F04438" : "#12B76A",
                  }}
                >
                  {currentItem.pendingQty}
                </strong>
              </div>
            </div>

            <div>
              <ProgressBar
                produced={currentItem.producedQty}
                required={currentItem.requiredQty || currentItem.totalQty || 1}
                mode={mode}
              />
            </div>

            {extraQty > 0 ? (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#F79009",
                }}
              >
                ⚠️ Extra Production: {extraQty} units.
                <br />
                extra production quantity add to order.
              </div>
            ) : (
              remainingQty !== 0 &&
              extraQty === 0 && (
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#12B76A",
                    marginBottom: 12,
                  }}
                >
                  ✅ Current qty update to the order and finish for production
                </div>
              )
            )}

            {remainingQty === 0 && extraQty === 0 && (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#12B76A",
                }}
              >
                ✅ Required production quantity completed successfully.
              </div>
            )}

            <div>
              {filteredItemsHistory?.length > 0 && (
                <>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: mode ? "#fff" : "#111",
                      marginBottom: 8,
                    }}
                  >
                    📋 Production History ({filteredItemsHistory.length} update
                    {filteredItemsHistory.length > 1 ? "s" : ""})
                  </div>

                  <div
                    style={{
                      maxHeight: 180,
                      overflowY: "auto",
                      backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
                      padding: "3px 10px",
                      borderRadius: 10,
                    }}
                  >
                    {filteredItemsHistory.map((h, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "7px 0",
                          borderBottom:
                            idx !== filteredItemsHistory.length - 1
                              ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
                              : "none",
                        }}
                      >
                        {/* Left side */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <span
                            style={{
                              color: "#12B76A",
                              fontWeight: 700,
                              fontSize: 14,
                            }}
                          >
                            {h.delta} units
                          </span>

                          {/* Show item only for Item/Production Line Wise */}
                          {h.itemNo && (
                            <span
                              style={{
                                fontSize: 11,
                                fontWeight: 600,
                                color: mode ? "#D1D5DB" : "#6B7280",
                                backgroundColor: mode ? "#292C32" : "#E9EDF5",
                                padding: "3px 7px",
                                borderRadius: 5,
                              }}
                            >
                              {h.itemNo}
                            </span>
                          )}
                        </div>

                        {/* Right side */}
                        <span
                          style={{
                            color: mode ? "#ffffff" : "#6B7280",
                            fontSize: 11,
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                            marginLeft: 10,
                          }}
                        >
                          {h.updatedBy || "Admin"} /{" "}
                          {formatDateTime(h.updateTime)}
                        </span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>

            {canSaveUpdate && activeType !== "Order Wise" && (
              <>
                <div className={styles.formGroup}>
                  <label>Add Production Qty</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={productionQty}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (/^\d*$/.test(value)) {
                        setProductionQty(value);
                      }
                    }}
                    placeholder="Enter qty..."
                  />
                </div>

                <div className={styles.quickBtns}>
                  {/* <button onClick={() => addQty(10)}>+10</button>
              <button onClick={() => addQty(20)}>+20</button>
              <button onClick={() => addQty(50)}>+50</button> */}
                  <Button
                    buttonClick={completeProduction}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#ffffff"}
                    buttonText={"Complete"}
                  />
                </div>
              </>
            )}

            {overProduceView && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: 10,
                  marginTop: 10,
                }}
              >
                <button
                  type="button"
                  onClick={() => setShowOverProduceInput((prev) => !prev)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: showOverProduceInput ? "#F93E3E" : "#4164E3",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  {showOverProduceInput ? "Cancel More Qty" : "+ Add More Qty"}
                </button>

                {showOverProduceInput && (
                  <div className={styles.formGroup} style={{ width: "100%" }}>
                    <label>Add Production Qty</label>

                    <input
                      type="text"
                      inputMode="numeric"
                      value={productionQty}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (/^\d*$/.test(value)) {
                          setProductionQty(value);
                        }
                      }}
                      placeholder="Enter extra qty..."
                    />
                  </div>
                )}
              </div>
            )}

            {/* {activeType !== "Order Wise" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  // onClick={handlePrintLabel}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "#4164E3",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  Print Production Label
                </button>
              </div>
            )} */}

            {activeType !== "Order Wise" && (
              <VerticalDropDown2
                height="37px"
                fontSize="12px"
                label="Production Line"
                dropDownText={
                  machineOptions.find((m) => m.value === machine)?.label ||
                  "Select Production Line"
                }
                options={machineOptions}
                value={{
                  label:
                    machineOptions.find((m) => m.value === machine)?.label ||
                    "Select Production Line",
                  value: machine,
                }}
                onchange={(option) => setMachine(option.value)}
                disableOpen={false}
              />
            )}
            {/* <div className={styles.formGroup}>
              <label>Status</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option>In Production</option>
                <option>Ready For Dispatch</option>
                <option>Completed</option>
                <option>Voucher</option>
              </select>
            </div> */}
          </div>
        </div>

        <div className={styles.drawerFooter}>
          <Button
            buttonClick={onClose}
            buttonText={"Close"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
          />

          {/* <Button
            loading={productionLoader}
            buttonClick={handleSaveProduction}
            buttonText={"Save Update"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
          /> */}

          {activeType !== "Order Wise" &&
            (overProduceView ? (
              <Button
                loading={productionLoader}
                buttonClick={handleOverSaveProductionClick}
                buttonText={"Save Update"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
              />
            ) : (
              <Button
                loading={productionLoader}
                buttonClick={handleSaveProductionClick}
                buttonText={currentStatus?.text || "Save Update"}
                buttonBgColor={currentStatus?.backgroundColor || "#4164E3"}
                buttonTextColor={currentStatus?.color || "#ffffff"}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default UpdateProductionDrawer;
